"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.getMonacoEditorSingleton = void 0;
const JADEConfigurationEditor_1 = require("./JADEConfigurationEditor");
function getMonacoEditorSingleton() {
    return JADEConfigurationEditor_1.JADEConfigurationEditor.getMonacoEditorSingleton();
}
exports.getMonacoEditorSingleton = getMonacoEditorSingleton;
function init(options) {
    try {
        return new JADEConfigurationEditor_1.JADEConfigurationEditor(options);
    }
    catch (error) {
        console.error(error);
        try {
            // @ts-ignore
            window.chrome.webview.postMessage({
                status: 'ERROR',
                name: 'initialization',
                data: {
                    message: error.message,
                    stack: error.stack
                }
            });
        }
        catch (chromeError) {
            console.error(error);
        }
    }
}
exports.init = init;
